export function portalDestinationForVerification(data) {
  return data?.purpose === "setup" ? "setup" : "portal";
}

export function buildClientSetupPayload({ setupToken, form, members }) {
  return {
    setup_token: setupToken,
    first_name: form.first_name,
    last_name: form.last_name,
    phone: form.phone,
    address: form.address,
    google_verification_token: form.google_verification_token || null,
    gender: form.gender,
    birth_year: form.birth_year,
    birth_month: form.birth_year ? 1 : null,
    dietary_restrictions: form.dietary_restrictions,
    household_members: members.map((member) => ({
      first_name: member.first_name,
      last_name: member.last_name,
      gender: member.gender,
      birth_year: member.birth_year,
      birth_month: member.birth_year ? 1 : null,
      relationship: member.relationship,
    })),
  };
}